import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import {
  FORMAT_TEXT_COMMAND,
  KEY_DOWN_COMMAND,
  COMMAND_PRIORITY_EDITOR,
} from 'lexical'

export function KeyBindingsPlugin() {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerCommand(
      KEY_DOWN_COMMAND,
      (e) => {
        const { key, metaKey, ctrlKey } = e
        const mod = metaKey || ctrlKey

        if (!mod) return false

        switch (key.toLowerCase()) {
          case 'b':
            editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold')
            return true
          case 'i':
            editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic')
            return true
          case 'u':
            editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline')
            return true
          case 'k':
            editor.dispatchCommand('SHOW_LINK_EDITOR', null)
            return true
          default:
            return false
        }
      },
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor])

  return null
}
